module.exports = __webpack_public_path__ + "img/1280.f2aeb8c0.svg";